import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_authenticated/campaign/$id')({
  params: {
    parse: ({ id }) => ({ id: z.coerce.number().int().positive().parse(id) }),
    stringify: ({ id }) => ({ id: String(id) }),
  },
  component: () => <Outlet />,
});
